import React from 'react';
import { BsArchive, BsCheck2Circle, BsTrash } from 'react-icons/bs';

import ConfirmActionWarningModal from '../../../../components/ConfirmActionWarningModal';
import StackedButtonGroup from '../../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import { inAppText } from '../../../../constants/inAppText';
import { archiveInsured, deleteInsured, reactivateInsured } from '../../../../redux/modules/insured';
import { hideModal, showModal } from '../../../../redux/modules/modal';
import { showDontAskAgainModal } from '../../../../utils/askAgainModalUtil';
import { confirmArchiveWithProcoreWarning, loadProcoreDeleteWarning } from '../../../../utils/procoreWarningModalUtil';
import { createToast } from '../../../../utils/toastUtil';

const handleDeleteInsured = async ({ e, dispatch }) => {
  e.preventDefault();
  e.stopPropagation();
  e.persist();
  const insuredId = parseInt(e.target.value, 10);
  const { procoreWarning } = await loadProcoreDeleteWarning(dispatch, 'insured');

  dispatch(showModal(
    () => (
      <ConfirmActionWarningModal
        description={inAppText.insuredsPage.insuredOptions.deleteInsuredMessage}
        procoreWarning={procoreWarning}
      />
    ),
    {
      title: 'Delete Insured?',
      size: 'md',
      buttons: {
        component: StackedButtonGroup,
        primaryButtonOptions: {
          label: 'Delete',
          isDisabled: true,
          onClick: () => {
            createToast({
              title: 'Deleting Insured...',
              duration: 10000
            });

            dispatch(deleteInsured(insuredId));
            dispatch(hideModal());
          }
        }
      }
    }
  ));
};

export const activeMenuOptions = [
  {
    label: 'Archive Insured',
    icon: BsArchive,
    id: 'archiveInsured',
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const insuredId = parseInt(e.target.value, 10);
      const cookieId = 'hideArchiveInsuredModal';
      const archiveCurrentInsured = () => {
        dispatch(hideModal());
        createToast({
          title: 'Archiving Insured...',
          status: 'info',
          duration: 10000
        });

        dispatch(archiveInsured(insuredId));
      };

      confirmArchiveWithProcoreWarning({
        dispatch,
        scope: 'insured',
        cookieId,
        description: inAppText.insuredsPage.insuredOptions.archiveInsuredMessage,
        onClick: archiveCurrentInsured,
        title: 'Archive Insured?'
      });
    }
  },
  {
    label: 'Delete Insured',
    icon: BsTrash,
    id: 'deleteInsured',
    handler: handleDeleteInsured
  }
];

export const archivedMenuOptions = [
  {
    label: 'Reactivate Insured',
    icon: BsCheck2Circle,
    id: 'reactivateInsured',
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const insuredId = parseInt(e.target.value, 10);
      const cookieId = 'hideActivateInsuredModal';

      const reactivateCurrentInsured = () => {
        dispatch(hideModal());
        createToast({
          title: 'Reactivating Insured...',
          status: 'info',
          duration: 10000
        });

        dispatch(reactivateInsured(insuredId));
      };

      showDontAskAgainModal({
        dispatch,
        cookieId,
        description: inAppText.insuredsPage.insuredOptions.reactivateInsuredMessage,
        onClick: reactivateCurrentInsured,
        title: 'Reactivate Insured?'
      });
    }
  },
  {
    label: 'Delete Insured',
    icon: BsTrash,
    id: 'deleteInsured',
    handler: handleDeleteInsured
  }
];
